import AssetFormat from 'umg-ember-backend/components/record-explorer/for/asset-format';

<template>
  <AssetFormat @records={{@model}} @recordType='asset-format' />
</template>
